import React, { useRef } from "react";
import { CgAttachment } from "react-icons/cg";
import ShowToast from "../common/components/showToast";
import { toastType } from "../constants";

// ✅ Supported file formats
const SUPPORTED_FILE_TYPES = [
  ".pdf",
  ".txt",
  ".json",
  ".docx",
  ".jpg",
  ".jpeg",
  ".png",
];

const SUPPORTED_MESSAGE =
  "You can upload documents (PDF, DOCX, TXT, JSON) or images (JPG, JPEG, PNG).";

const AttachmentInput = ({ onSelect, disabled, position }) => {
  const fileInputRef = useRef(null);

  const handleFileSelection = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    if (selectedFiles.length === 0) return;

    const allowedFiles = [];
    const blockedTypes = new Set(); // prevent duplicate extensions

    selectedFiles.forEach((file) => {
      const fileName = (file.name || "").toLowerCase();
      const fileExt = "." + fileName.split(".").pop(); // extract extension

      if (SUPPORTED_FILE_TYPES.includes(fileExt)) {
        allowedFiles.push(file);
      } else {
        blockedTypes.add(fileExt);
      }
    });

    if (fileInputRef.current) fileInputRef.current.value = "";

    if (blockedTypes.size > 0) {
      const badTypes = Array.from(blockedTypes)
        .map((ext) => ext.toUpperCase().replace(".", ""))
        .join(", ");

      const message =
        blockedTypes.size === 1
          ? `${badTypes} files are not supported.\n${SUPPORTED_MESSAGE}`
          : `Some file types are not supported: ${badTypes}.\n${SUPPORTED_MESSAGE}`;

      ShowToast({
        message,
        type: toastType.ERROR,
      });
      console.error(`Unsupported file types: ${badTypes}`);
    }

    if (allowedFiles.length > 0) {
      onSelect(allowedFiles);
    }
  };

  return (
    <div className={`absolute left-4.5 ${position}`}>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept={SUPPORTED_FILE_TYPES.join(",")}
        onChange={handleFileSelection}
        multiple
      />
      <button
        onClick={() => fileInputRef.current?.click()}
        disabled={disabled}
        className="mr-4"
      >
        <CgAttachment />
      </button>
    </div>
  );
};

export default AttachmentInput;
